import { useEffect, useState } from 'react';
import { ChatHeaderCompose, ChatHeaderDetail } from '.';
import { CHAT_MODES } from '../constants/ChatModes';
import { useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { Button, IconButton } from '@mui/material';
import { addRecipients } from 'src/redux/slices/chat';
import { useTranslation } from 'react-i18next';

const ChatHeader = ({
  mode,
  conversation,
  contacts,
  recipients,
  addUsersToGroup,
}) => {
  const [chatMode, setChatMode] = useState(CHAT_MODES[mode]);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const chatContacts = conversation.id
    ? contacts.filter(
        (user) =>
          !conversation.participants.some(
            (participant) => participant.id === user.id
          )
      )
    : contacts;

  const toggleShowRecipients = () =>
    setChatMode(
      chatMode === CHAT_MODES.COMPOSE ? CHAT_MODES.DETAIL : CHAT_MODES.COMPOSE
    );

  const handleAddRecipients = (recipients) => {
    dispatch(addRecipients(recipients));
  };

  useEffect(() => {
    if (!conversation.id) return;
    dispatch(addRecipients([]));
  }, [conversation.id]);

  if (chatMode === CHAT_MODES.DETAIL)
    return (
      <ChatHeaderDetail
        conversation={conversation}
        conversationName={conversation?.name}
        onAddRecipients={toggleShowRecipients}
      />
    );

  return (
    <ChatHeaderCompose
      conversation={conversation}
      recipients={recipients}
      contacts={chatContacts}
      onAddRecipients={handleAddRecipients}
      showDetailsIcon={
        conversation?.id ? (
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setChatMode(CHAT_MODES.DETAIL);
                addUsersToGroup(recipients, conversation.id);
              }}
              disabled={!recipients.length}
            >
              {t('chat.add_participants_button_text')}
            </Button>
            <IconButton
              onClick={() => {
                toggleShowRecipients();
                dispatch(addRecipients([]));
              }}
            >
              <CloseIcon width={20} height={20} />
            </IconButton>
          </>
        ) : null
      }
    />
  );
};

export default ChatHeader;
